import React, { Component } from "react";
import axios from "axios";
import _ from "lodash";
import { renderMarkup } from "../utils.js";
import Hero from "./Hero.js";
import OurTeam from "./OurTeam.js";
import edge from "../assets/edge.svg";

class Company extends Component {
  constructor() {
    super();
    this.state = {
      data: null
    };
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/pages?slug=company").then(res => {
      this.setState(
        {
          data: res.data[0].acf
          //   pageTitle: res.data[0].title.rendered,
          //   seo: res.data[0].yoast_meta,
          //   pageContent: res.data[0].content.rendered,
          //   sectionTitle: res.data[0].acf.team_section_headline,
          //   featuredImage: res.data[0].better_featured_image.source_url
        },
        () => window.scrollTo(0, 0)
      );
    });
    axios.get(SITE_URL + "/wp-json/wp/v2/logos").then(res => {
      this.setState({
        logos: res.data
        //   pageTitle: res.data[0].title.rendered,
        //   seo: res.data[0].yoast_meta,
        //   pageContent: res.data[0].content.rendered,
        //   sectionTitle: res.data[0].acf.team_section_headline,
        //   featuredImage: res.data[0].better_featured_image.source_url
      });
    });
  }

  renderLogoBar() {
    const { logos } = this.state;
    if (logos) {
      return _.map(logos, o => {
        return (
          <div className="logo-item">
            <img alt="logo" src={o.acf.image_file} />
          </div>
        );
      });
    }
  }

  render() {
    const { data, logos } = this.state;
    if (data) {
      return (
        <div>
          <Hero
            link
            content={data.content_hero}
            linkTitle={data.link_title_hero}
            linkUrl={data.link_url_hero}
            image={data.background_image}
            data={data}
          />

          <div className="about-us">
            <img className="edge" src={edge} alt="Edge Element" />
            <div className="wrapper inner">
              <div className="about-us">
                <div className="inner">
                  <div
                    className="left"
                    dangerouslySetInnerHTML={renderMarkup(data.content_about)}
                  />
                  <div
                    className="right"
                    dangerouslySetInnerHTML={renderMarkup(data.offerings_about)}
                  />
                </div>
              </div>
            </div>
          </div>

          <OurTeam data={data} />

          <div className="all-logos">
            <div className="inner">
              <h2>Clients Who Rely on OnCourse</h2>
              {this.renderLogoBar()}
            </div>
          </div>
        </div>
      );
    } else return false;
  }
}

export default Company;



// WEBPACK FOOTER //
// ./src/components/Company.js